
export default {
  namespaced: true,

  state: {
    selectedIndex: -1
  },

  mutations: {
    setSelectedIndex: (state, payload) => {
      console.log('Index = ', payload)
      state.selectedIndex = payload
    },
  },
}